import $ from "jquery";
import _ from "lodash";
import Velocity from "velocity-animate";
import cookie from "js-cookie";
import qs from "query-string";
import "jquery-modal";

import initJQuery from "lib/vendor/jquery";
import wsStorage, { WS_STORAGE_KEY } from "lib/wsStorage";

import util from "./util";
import events from "./events";
import views from "./views";
import component from "./components";
import social from "./social";
import auth from "./components/auth";
import { InviteCardsModal } from "./components/invites";
import { updateMatchesCount } from "./views/matches";

import initSOHP from "./views/sohp";
import initJobList from "./views/job-list";
import initWithdraw from "./views/withdraw";
import initTOSUpdate from "./views/tos-update";

export default () => {
    if (!Velocity.Promise) {
        Velocity.Promise = window.Promise;
    }

    const $body = $("body");

    $("[data-dropdown]").on("click", (event) => {
        event.preventDefault();

        const $dropdown = $(event.currentTarget).closest(".dropdown");
        const isNav = $dropdown.closest("#nav").length > 0;
        $dropdown.toggleClass("active");

        // Use data-close-on-inner-click to have the dropdown close when a click
        // happens inside of it. By default, it will stay open.
        const closeOnClick = $dropdown.data("closeOnInnerClick");

        if ($dropdown.hasClass("active")) {
            $body.on("click.dropdown", (event2) => {
                const $el = $(event2.target);
                if (closeOnClick || !$dropdown.find($el).length) {
                    $body.off("click.dropdown");
                    $dropdown.removeClass("active");

                    if (isNav) {
                        $("#nav").css("z-index", "999");
                    }
                }
            });

            if (isNav) {
                $("#nav").css("z-index", "1001");
            }
        } else {
            $body.off("click.dropdown");

            if (isNav) {
                $("#nav").css("z-index", "999");
            }
        }
    });

    $(".js-need-help").on("click", () => {
        $("#need-help-modal").modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        events.track("need-help-modal", "click");

        return false;
    });

    initJQuery();

    const search = window.location.search.substring(1).replace(/,/g, "%20");
    if (search.indexOf("utm_") > -1) {
        let utm = cookie.get("utm") ? qs.parse(cookie.get("utm")) : {};
        const searchUtm = qs.parse(search);
        const searchSource = searchUtm.utm_source;

        const pdnw = cookie.get("pdnw_source") || "";
        if (searchSource && searchSource !== pdnw.replace("_", "")) {
            cookie.set("pdnw_source", searchSource, { expires: 1 / 24 }); // 1 hour
        }

        // If we have a new utm_source, clear out old utm_*, otherwise just update
        utm = searchSource ? searchUtm : _.extend(utm, searchUtm);

        Object.keys(utm).forEach((key) => {
            if (!utm[key] || key.substr(0, 4) !== "utm_") {
                delete utm[key];
            }
        });

        cookie.set("utm", qs.stringify(utm), { expires: 2 }); // days

        const current = cookie.get("search");
        if (!current || current.split(",")[0] !== search) {
            cookie.set("search", `${search},${current || ""}`);
        }
    }

    // used by views/step.js
    window.loaded = false;
    $(window).on("load", () => {
        window.loaded = true;
    });

    $(document).keypress((e) => {
        if (e.which === 13 && $(".dropdown-button").length && !$(".modal").length) {
            window.location = $(".dropdown-button").attr("href");
        }
    });

    // A nice place to centralize the events for jQuery handlers throughout,
    // in case we want to modify
    const eventType = "click";

    initSOHP();
    initJobList();

    if ($("#pagination").length) {
        new component.PaginationComponent({ el: "#pagination" }).render();
    }

    if ($("#app-container").length) {
        const app = new views.ApplicationContainer({ el: "#app-container" });
        app.render();
    }

    if ($("#profile-container").length) {
        new views.ProfileContainer({ el: "#profile-container" }).render();
    }

    if ($("#withdraw-main").length) {
        initWithdraw();
    }

    if ($("#matches-container").length) {
        new views.MatchesView({ el: "#matches-container" }).render();
    } else {
        updateMatchesCount();
    }

    const showInvitePop = $(".js-show-invite-pop").length > 0;
    if (showInvitePop) {
        const $modal = $("<div></div>");
        $body.append($modal);
        new InviteCardsModal({
            el: $modal,
        }).render();
    }

    if ($(".event-register").length) {
        new views.EventRegisterView({
            el: ".event-register",
        }).render();
    }

    if ($(".program-register").length) {
        new views.ProgramRegisterView({
            el: ".program-register",
        }).render();
    }

    if ($("#referral-container").length) {
        const campaign = util.getQueryParam("c");
        new component.Referral.View({
            el: "#referral-container",
            campaign: campaign || "candref",
            showFooter: !!campaign,
        }).render();
    }

    if ($("#feedback-main").length) {
        new views.InterviewFeedback().render();
    }

    if (!showInvitePop && $(".page-candidate-home").length) {
        const count = window.appCount;
        const storageKey = "refmodal";
        const refShown = Number(wsStorage.getItem(storageKey) || 0);
        // Legacy keys didn't include an expiry, so catch 'em and reset 'em
        const canExpire = wsStorage.canExpire(storageKey);
        const reset = util.getQueryParam("reset");

        // Pop up referral modal every 30 days after they've completed 3 apps
        // Don't interrupt the password reset modal
        if (!reset && count >= 3 && (!refShown || !canExpire)) {
            wsStorage.setItem(storageKey, count, 60 * 60 * 24 * 30 * 1000);

            setTimeout(() => {
                events.track("REFERRAL_MODAL", "candhome_auto");

                new component.Referral.Modal({
                    campaign: "candhomepop",
                }).render();
            }, 2000);
        }
    }

    const redirect = util.getQueryParam("redirect");
    const login = util.getQueryParam("login");
    if ($(".login-container-inline").length) {
        new auth.AuthComponent({
            el: ".login-container-inline",
            redirect: redirect || window.redirect || "/",
            loginHandle: window.loginHandle || "",
            inline: true,
            level: login,
        }).render();
    }

    $(".js-menu-toggle").on(eventType, (e) => {
        const target = e.currentTarget;
        if (e.target !== target && e.target.parentElement !== target) {
            return;
        }

        e.preventDefault();
        $(target).toggleClass("active");
    });

    $(".js-reset-link").on(eventType, (e) => {
        e.preventDefault();

        new auth.AuthComponent({
            redirect: e.target.dataset.redirect || "/",
            level: auth.LOGIN_LEVEL.RESET,
        }).render();
    });

    $body.on(eventType, ".js-toggle-signup-link", (e) => {
        e.preventDefault();

        cookie.remove("wslogin");
        events.trackLoginEvent("show-signup");

        const query = qs.parse(window.location.search);
        delete query.usr;
        const url = `${window.location.pathname}?${qs.stringify(query)}`;

        setTimeout(() => {
            window.location.href = url;
        }, 0);
    });

    function showAccountModal() {
        new component.Account().render();
    }

    function showPreferencesModal() {
        new component.Preferences.Modal().render();
    }

    $body.on("click", ".js-edit-account", (event) => {
        event.preventDefault();
        showAccountModal();
    });

    $body.on("click", ".js-edit-preferences", (event) => {
        event.preventDefault();

        if ($(event.target).data("reload")) {
            window.location.hash = $(event.target).data("reload");
        }

        showPreferencesModal();
    });

    $body.on("click", ".js-show-referral", (event) => {
        event.preventDefault();

        const $target = $(event.currentTarget);
        const campaign = $target.data("campaign") || "";
        events.track("REFERRAL_MODAL", campaign || "open");

        new component.Referral.Modal({
            header: $target.data("header"),
            subheader: $target.data("subheader"),
            campaign,
            medium: $target.data("medium") || "",
            url: $target.data("url") || "",
            pid: $target.data("pid") || "",
        }).render();
    });

    $body.on("click", ".js-referral-redirect", (event) => {
        event.preventDefault();

        const $target = $(event.currentTarget);
        const campaign = $target.data("campaign") || "";

        util.redirectToReferral(
            // Show first and every other time
            (count) => count % 2 === 1,
            campaign,
            $target.data("url"),
        );
    });

    $body.on("click", ".js-social-invite", (event) => {
        event.preventDefault();

        const $target = $(event.currentTarget);

        const network = $target.data("network");
        const text = $target.data("text") || "";
        let url =
            $target.data("url") ||
            `${window.location.protocol}//${window.location.hostname}/signup`;
        const source = $target.data("source") || "ws-ref";
        const medium = $target.data("medium") || network;
        const campaign = $target.data("campaign") || "referral";

        const connector = url.indexOf("?") > -1 ? "&" : "?";
        url += `${connector}utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`;

        events.track(`REFERRAL_INVITE_${network.toUpperCase()}`, campaign);

        social.showPopup(network, url, text);
    });

    if (window.authUser) {
        if (window.location.hash === "#account") {
            showAccountModal();
        } else if (window.location.hash === "#preferences") {
            showPreferencesModal();
        }
    } else if (wsStorage.getItem(WS_STORAGE_KEY.STOP_RESET_PASSWORD)) {
        wsStorage.removeItem(WS_STORAGE_KEY.STOP_RESET_PASSWORD);
    }

    // Recruitics pixel
    if (
        window.location.search.indexOf("utm_source=rx") > -1 &&
        (window.location.pathname.indexOf("featured/") > -1 ||
            window.location.pathname.indexOf("featured-job/") > -1)
    ) {
        events.trackRecruitics("jobview");
    }

    // Pando pixel
    if (
        window.location.search.indexOf("utm_source=pando") > -1 &&
        (window.location.pathname.indexOf("featured/") > -1 ||
            window.location.pathname.indexOf("featured-job/") > -1)
    ) {
        events.trackPando("jobview");
    }

    // indeed pixel
    if (
        window.location.search.indexOf("utm_source=in2") > -1 &&
        (window.location.pathname.indexOf("featured/") > -1 ||
            window.location.pathname.indexOf("featured-job/") > -1)
    ) {
        events.trackIndeed2("recordLanding");
    }

    initTOSUpdate();

    /* eslint-disable */
    //  Thanks! https://css-tricks.com/snippets/jquery/smooth-scrolling/
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (t) {
            if (
                location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
                location.hostname == this.hostname
            ) {
                let e = $(this.hash);
                (e = e.length ? e : $(`[name=${this.hash.slice(1)}]`)),
                    e.length &&
                        (t.preventDefault(),
                        $("html, body").animate({ scrollTop: e.offset().top }, 1e3, () => {
                            const t = $(e);
                            return (
                                t.focus(),
                                t.is(":focus") ? !1 : (t.attr("tabindex", "-1"), void t.focus())
                            );
                        }));
            }
        });
    /* eslint-enable */
};
